import { Flame } from "lucide-react";
import { scrollToId } from "@/lib/api";

const LINKS = [
  ["LIVE FEED", "#demo", "live-feed"],
];

export default function Nav({ user, onLogin, onLogout, onProfile, onAdmin, bannerOffset }) {
  return (
    <header
      data-testid="main-nav"
      className={`glass-nav fixed left-0 right-0 z-50 ${bannerOffset ? "top-9" : "top-0"}`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center gap-3"
        >
          <span className="grid h-9 w-9 place-items-center bg-[#FF3B30] text-black transition-colors duration-300 hover:bg-[#FF6B00]">
            <Flame className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <span className="font-chivo text-lg font-black tracking-tight text-white">
            PRIVATE<span className="text-[#FF3B30]"> FIRE ALERTS</span>
          </span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, id, key]) => (
            <button
              key={id}
              data-testid={`nav-link-${key}`}
              onClick={() => scrollToId(id)}
              className="font-jb text-[11px] tracking-[0.25em] text-zinc-400 transition-colors duration-300 hover:text-white"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <button
                data-testid="nav-profile-btn"
                onClick={onProfile}
                title="My crew profile"
                className="hidden font-jb text-[10px] tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-[#FF5247] lg:block"
              >
                {(user.name || user.email).toUpperCase()}
              </button>
              {user.role === "admin" && (
                <button
                  data-testid="nav-admin-btn"
                  onClick={onAdmin}
                  className="border border-[#FFC107]/60 bg-[#FFC107]/10 px-4 py-2 font-jb text-[11px] tracking-[0.2em] text-[#FFC107] transition-colors duration-300 hover:bg-[#FFC107] hover:text-black"
                >
                  ADMIN
                </button>
              )}
              <button
                data-testid="nav-logout-btn"
                onClick={onLogout}
                className="border border-zinc-700 px-4 py-2 font-jb text-[11px] tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:border-[#FF3B30] hover:text-white"
              >
                LOG OUT
              </button>
            </>
          ) : (
            <button
              data-testid="nav-login-btn"
              onClick={onLogin}
              className="border border-zinc-700 px-4 py-2 font-jb text-[11px] tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:border-[#FF3B30] hover:text-white"
            >
              LOG IN
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
